var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('VLayout',{staticClass:"loading-overlay",class:{ overlay: _vm.loading }},[_c('ul',{staticClass:"loader"},[_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li')])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }